import styled from 'styled-components';
import InternalContainer from 'components/internal-container/internal-container';

export const TableActions = styled(InternalContainer)`
  border-radius: 0px 0px 6px 6px;
  background: white;
  padding: 10px 23px;
`;

interface ButtonProps {
  active?: boolean;
  arrow?: boolean;
}

export const Button = styled.button<ButtonProps>`
  margin: 0px 3px;
  background: ${({ active, arrow }) =>
    active ? '#4A90E2' : arrow ? '#F2F2F2' : 'white'};
  :focus {
    color: ${({ arrow }) => arrow && '#343a40'};
  }
  color: ${({ active, arrow }) =>
    active ? 'white  ' : arrow ? '#C5C5C5' : '#6c757d  '};
  font-size: ${({ arrow }) => (arrow ? '13px' : '12px')};
  font-weight: 500;
  border: none;
  height: 25px;
  width: 25px;
  border-radius: 2px;
`;
